import { render } from "./UniPage.vue?vue&type=template&id=14203f7c"
import script from "./UniPage.vue?vue&type=script&lang=js"
export * from "./UniPage.vue?vue&type=script&lang=js"

import "./UniPage.vue?vue&type=style&index=0&id=14203f7c&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__